import { createStore } from 'effector';

export const $modalOpen = createStore(false);
